import { getDateWithSpecificFormat } from '../../../../data-transform';

const constructCountryNames = (countries = []) => {
    // let countriesList = countries.map(country => {
    //     return getCountryNameByCountryCode(country);
    // });
    return countries.join(", ");
}

export default function hpRevitalizeColumnSpecification(config) {
    if (!config.data) return null;
    const { vendorQuoteDetails = [], quoteDetails = {}, conversionRateType = '', countryCurrency,countryList } = config.data;

    const getCurrencyCode = () => {
        if (conversionRateType === 'USD' || conversionRateType === 'EUR') {
            return conversionRateType
        }
        else if (quoteDetails.region === "EMEA" && countryList.length > 1) {
            return "EUR"
        }
        else if (countryList.length === 1) {
            return countryCurrency[countryList[0]];
        } else if (countryList.length > 1) {
            return "USD"
        }
    }

    let result = {};
    let tableData = [];
    let row = [];
    const rowId = config.tableType;

    config.columns.forEach(column => {
        const columnId = column.id;
        const displayAsIs = column.data.displayInBodyAsIs;
        const columnDataType = column.data.displayInBodyAs;
        const highlightColumn = column.data.highlightBodyText;

        let columnValue = null;
        let isDisabled = false;
        if (columnDataType === "string") {
            if (columnId === "quotationNumber") {
                columnValue = quoteDetails.quoteId;
            }
            if (columnId === "quotationSubmissionDateByHp") {
                columnValue = getDateWithSpecificFormat(quoteDetails.updatedDate);
            }
            if (columnId === "listofRevitalizeCountriesQuoted") {
                if(quoteDetails.revCountryList){
                    let RevitalizeCountriesList = quoteDetails.revCountryList.join(', ');
                    columnValue = RevitalizeCountriesList;
                }
                else{columnValue = quoteDetails.revitalizeCountries;} 
            }
            if (columnId === "numberofRevitalizeCountries") {
                columnValue = quoteDetails.numberOfRevitalizeCountry || "0";
            }
            else if (columnId === "currency") {
                columnValue = getCurrencyCode() || "";
            }
            else if (columnId === "hpBuybackValue") {
                columnValue = quoteDetails?.vhardwareRevitalizeFees?.toFixed(2) || "";
            }
        }

        row.push({
            [columnId]: {
                id: columnId + "|" + rowId,
                columnId: columnId,
                type: columnDataType,
                value: columnValue,
                width: column.width,
                displayAsIs: displayAsIs,
                showInMobileViewAs: column.showInMobileViewAs,
                highlightColumn: highlightColumn,
                disabled: isDisabled
            }
        });
    });

    tableData.push({
        id: rowId,
        data: row
    });

    result['columns'] = config.columns || [];
    result['data'] = tableData || [];

    return result;
}